export const FirstOrderDiscount = "FirstOrderDiscount";
